import { RouteInfo } from "./vertical-sidebar.metadata";
import {
  DASHBOARDS_MODULE_ROLES,
  DASHBOARD_EP_MAIN_ROLES,
  DASHBOARD_EDITOR_BILLINGS_ROLES,
  DASHBOARD_HOLDCO_REVENUE_ROLES,
  DASHBOARD_QUARTERLY_SUMS_ROLES,
  DASHBOARD_EP_LOW_MARGIN_ROLES,
  DASHBOARD_REVENUE_BY_SOURCE_ROLES,
  DASHBOARD_CUSTOMER_BRAND_CONCENTRATION_ROLES,
  DASHBOARD_TRENDS_ANALYSIS_ROLES,
  INVOICES_MODULE_ROLES,
  INVOICES_AR_AGING_ROLES,
  PROJECTS_UNBILLED_ROLES,
  INVOICES_LIST_ROLES,
  INVOICES_PAYMENT_FORECAST_ROLES,
  INVOICES_PAYMENT_TIMING_ROLES,
  INVOICES_MONTHLY_TOTALS_ROLES,
  PAYABLES_AP_PWP_ROLES,
  PAYABLES_PO_CHECK_ROLES,
  INVOICES_CHECK_ROLES,
  LEADS_MODULE_ROLES,
  LEADS_TRACKER_ROLES,
  LEADS_BID_GROUP_CALCULATOR_ROLES,
  LEADS_ROLES,
  LEADS_REPORT_ROLES,
  LEADS_AWARDED_SUMMARY_ROLES,
  CHECKS_MODULE_ROLES,
  PROJECTS_MODULE_ROLES,
  PROJECTS_LIST_ROLES,
  PROJECTS_INCOME_EXPENSES_ROLES,
  PROJECTS_NEW_ROLES,
  ALLOCATIONS_ROLES,
  PROJECTS_MISSING_FIELDS_ROLES,
  PROJECTS_RELATED_CHECK_ROLES,
  ADMIN_MODULE_ROLES,
  ADMIN_USERS_ROLES,
  DELEGATED_USER_MANAGEMENT_PERMISSIONS,
  ADMIN_QUARTERS_ROLES,
  ADMIN_REPORTING_ENTITIES_ROLES,
  ADMIN_COMPANIES_ROLES,
  ADMIN_DIVISIONS_ROLES,
  ADMIN_RESOURCES_ROLES,
  ADMIN_CUSTOMERS_ROLES,
  ADMIN_CUSTOMER_STATES_ROLES,
  ADMIN_QB_CUSTOMERS_ROLES,
  IMPORT_MODULE_ROLES,
  PROJECTS_IMPORT_ROLES,
  ALLOCATIONS_IMPORT_ROLES,
  PROJECTS_MISSING_FIELDS_IMPORT_ROLES
} from "../../_constants/role-permissions";

export const ROUTES: RouteInfo[] = [
  {
    path: 'dashboards',
    title: 'Dashboards',
    icon: 'Pie-Chart',
    class: 'has-arrow',
    extralink: false,
    label: '',
    labelClass: '',
    submenu: [
      {
        path: '/dashboards/holdco-revenue',
        title: 'Revenue',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: DASHBOARD_HOLDCO_REVENUE_ROLES
      },
      {
        path: '/dashboards/ep-main',
        title: 'EP Main',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: DASHBOARD_EP_MAIN_ROLES
      },
      {
        path: '/dashboards/editor-billings',
        title: 'Editor Billings',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: DASHBOARD_EDITOR_BILLINGS_ROLES
      },
      {
        path: '/dashboards/customer-and-brand-concentration',
        title: 'Customer & Brand Concentration',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: DASHBOARD_CUSTOMER_BRAND_CONCENTRATION_ROLES
      },
      {
        path: '/dashboards/trends-analysis',
        title: 'Trends Analysis',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: DASHBOARD_TRENDS_ANALYSIS_ROLES
      },
      {
        path: '/dashboards/ep-low-margin',
        title: 'EP Investment Projects',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: DASHBOARD_EP_LOW_MARGIN_ROLES
      },
      {
        path: '/dashboards/quarterly-sums',
        title: 'Quarterly Sums',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: DASHBOARD_QUARTERLY_SUMS_ROLES
      },
      {
        path: '/dashboards/revenue-by-source',
        title: 'Revenue by Source',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: DASHBOARD_REVENUE_BY_SOURCE_ROLES
      },
    ],
    roles: DASHBOARDS_MODULE_ROLES
  },
  {
    path: 'invoices',
    title: 'Invoices',
    icon: 'Dollar-Sign',
    class: 'has-arrow',
    extralink: false,
    label: '',
    labelClass: '',
    submenu: [
      {
        path: '/invoices/ar-aging',
        title: 'AR Aging',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: INVOICES_AR_AGING_ROLES
      },
      {
        path: '/invoices/unbilled-projects',
        title: 'Unbilled',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: PROJECTS_UNBILLED_ROLES
      },
      {
        path: '/invoices/list',
        title: 'Invoices List',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: INVOICES_LIST_ROLES
      },
      {
        path: '/invoices/payment-forecast',
        title: 'Payment Forecast',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: INVOICES_PAYMENT_FORECAST_ROLES
      },
      {
        path: '/invoices/payment-timing',
        title: 'Payment Timing (Hist.)',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: INVOICES_PAYMENT_TIMING_ROLES
      },
      {
        path: '/invoices/monthly-totals',
        title: 'Monthly Invoice Totals',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: INVOICES_MONTHLY_TOTALS_ROLES
      },
      {
        path: '/invoices/ap-pwp',
        title: 'AP PWP',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: PAYABLES_AP_PWP_ROLES
      },
    ],
    roles: INVOICES_MODULE_ROLES
  },
  {
    path: 'leads',
    title: 'Leads',
    icon: 'Target',
    class: 'has-arrow',
    extralink: false,
    label: '',
    labelClass: '',
    submenu: [
      {
        path: '/leads/leads-tracker',
        title: 'Leads Tracker',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: LEADS_TRACKER_ROLES
      },
      {
        path: '/leads',
        title: '(Legacy) Leads List',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: LEADS_ROLES
      },
      {
        path: '/leads/report',
        title: '(Legacy) Leads Report',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: LEADS_REPORT_ROLES
      },
      {
        path: '/leads/awarded-leads-summary',
        title: '(Legacy) Awarded Leads Summary',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: LEADS_AWARDED_SUMMARY_ROLES
      }
    ],
    roles: LEADS_MODULE_ROLES
  },
  {
    // A top-level leaf, not an expander: `class: ''` is what makes the sidebar template bind the
    // routerLink instead of treating the entry as a submenu toggle, and the path needs its leading
    // slash because it is resolved as an actual link.
    path: '/split-calculator',
    title: 'Split Calculator',
    icon: 'Divide-Circle',
    class: '',
    extralink: false,
    label: '',
    labelClass: '',
    submenu: [],
    roles: LEADS_BID_GROUP_CALCULATOR_ROLES
  },
  {
    path: 'checks',
    title: 'Checks',
    icon: 'Check-Square',
    class: 'has-arrow',
    extralink: false,
    label: '',
    labelClass: '',
    submenu: [
      {
        path: '/checks/po',
        title: 'PO Check',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: PAYABLES_PO_CHECK_ROLES
      },
      {
        path: '/checks/invoices',
        title: 'Invoice Check',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: INVOICES_CHECK_ROLES
      },
      {
        path: '/checks/missing-fields',
        title: 'Missing Fields',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: PROJECTS_MISSING_FIELDS_ROLES
      },
      {
        path: '/checks/linked-projects',
        title: 'Linked Projects Check',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: PROJECTS_RELATED_CHECK_ROLES
      }
    ],
    roles: CHECKS_MODULE_ROLES
  },
  {
    path: 'projects',
    title: 'Projects',
    icon: 'Folder',
    class: 'has-arrow',
    extralink: false,
    label: '',
    labelClass: '',
    submenu: [
      {
        path: '/projects/list',
        title: 'Projects List',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: PROJECTS_LIST_ROLES
      },
      {
        path: '/projects/income-expenses',
        title: 'Income & Expenses',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: PROJECTS_INCOME_EXPENSES_ROLES
      },
      {
        path: '/projects/new',
        title: 'Add Project',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: PROJECTS_NEW_ROLES
      },
      {
        path: '/allocations',
        title: 'Allocations',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: ALLOCATIONS_ROLES
      }
    ],
    roles: PROJECTS_MODULE_ROLES
  },
  {
    path: 'admin',
    title: 'Admin',
    icon: 'Settings',
    class: 'has-arrow',
    extralink: false,
    label: '',
    labelClass: '',
    submenu: [
      {
        path: '/admin/users',
        title: 'Users',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: ADMIN_USERS_ROLES,
        // Delegated managers are not admins, so they reach Users by capability (SPAR-745).
        permissions: DELEGATED_USER_MANAGEMENT_PERMISSIONS
      },
      {
        path: '/admin/quarters',
        title: 'Quarters',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: ADMIN_QUARTERS_ROLES
      },
      {
        path: '/admin/reporting-entities',
        title: 'Reporting Entities',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: ADMIN_REPORTING_ENTITIES_ROLES
      },
      {
        path: '/admin/companies',
        title: 'Companies',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: ADMIN_COMPANIES_ROLES
      },
      {
        path: '/admin/divisions',
        title: 'Divisions',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: ADMIN_DIVISIONS_ROLES
      },
      {
        path: '/admin/resources',
        title: 'Resources',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: ADMIN_RESOURCES_ROLES
      },
      {
        path: '/admin/customers',
        title: 'Customers',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: ADMIN_CUSTOMERS_ROLES
      },
      {
        path: '/admin/customer-states',
        title: 'Customer States',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: ADMIN_CUSTOMER_STATES_ROLES
      },
      {
        path: '/admin/qb-customers',
        title: 'Clients/Agencies (QBO Customers)',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: ADMIN_QB_CUSTOMERS_ROLES
      }
    ],
    roles: ADMIN_MODULE_ROLES,
    // Without this the Admin parent is filtered out for a delegated manager and the Users entry
    // above it never renders, however visible the child itself is (SPAR-745).
    permissions: DELEGATED_USER_MANAGEMENT_PERMISSIONS
  },
  {
    path: 'import',
    title: 'Import',
    icon: 'Upload',
    class: 'has-arrow',
    extralink: false,
    label: '',
    labelClass: '',
    submenu: [
      {
        path: '/projects/import',
        title: 'Projects CSV',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: PROJECTS_IMPORT_ROLES
      },
      {
        path: '/allocations/import',
        title: 'Allocations CSV',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: ALLOCATIONS_IMPORT_ROLES
      },
      {
        path: '/projects/missing-fields/import',
        title: 'Missing Fields CSV',
        icon: 'mdi mdi-record',
        class: '',
        label: '',
        labelClass: '',
        extralink: false,
        submenu: [],
        roles: PROJECTS_MISSING_FIELDS_IMPORT_ROLES
      }
    ],
    roles: IMPORT_MODULE_ROLES
  }
];
